import { useEffect, useMemo, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

// Select com campo de busca: clique abre a lista, digitar filtra as opções.
// `options` é um array de { value, label }. Compatível com o estilo dos <select>
// nativos usados nos modais de Gestão Orçamentária (mesma paleta C).
export default function ComboBoxFiltravel({ C, value, onChange, options, placeholder = "Selecione…", emptyLabel = "Nenhuma opção encontrada" }) {
  const [aberto, setAberto] = useState(false);
  const [filtro, setFiltro] = useState("");
  const raizRef = useRef(null);

  const selecionado = options.find((o) => String(o.value) === String(value));

  useEffect(() => {
    if (!aberto) setFiltro("");
  }, [aberto]);

  useEffect(() => {
    function aoClicarFora(e) {
      if (raizRef.current && !raizRef.current.contains(e.target)) setAberto(false);
    }
    document.addEventListener("mousedown", aoClicarFora);
    return () => document.removeEventListener("mousedown", aoClicarFora);
  }, []);

  const opcoesFiltradas = useMemo(() => {
    const termo = filtro.trim().toLowerCase();
    if (!termo) return options;
    return options.filter((o) => o.label.toLowerCase().includes(termo));
  }, [filtro, options]);

  return (
    <div ref={raizRef} style={{ position: "relative" }}>
      <div
        onClick={() => setAberto((v) => !v)}
        style={{
          background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8,
          padding: "9px 12px", fontSize: 13, color: selecionado ? C.text : C.muted,
          fontFamily: "inherit", cursor: "pointer", display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 8,
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {selecionado ? selecionado.label : placeholder}
        </span>
        <ChevronDown size={14} style={{ flexShrink: 0, opacity: 0.6 }} />
      </div>

      {aberto && (
        <div style={{
          position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 30,
          background: C.card, border: `1px solid ${C.border}`, borderRadius: 8,
          boxShadow: "0 12px 32px rgba(0,0,0,0.25)", overflow: "hidden",
        }}>
          <input
            autoFocus
            type="text"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            placeholder="Digite para filtrar…"
            style={{
              width: "100%", boxSizing: "border-box", background: C.bg, border: "none",
              borderBottom: `1px solid ${C.border}`, padding: "9px 12px", fontSize: 13,
              color: C.text, fontFamily: "inherit", outline: "none",
            }}
          />
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            {value !== "" && value != null && (
              <div
                onClick={() => { onChange(""); setAberto(false); }}
                style={{ padding: "8px 12px", fontSize: 13, color: C.muted, cursor: "pointer", fontStyle: "italic" }}
              >
                Limpar seleção
              </div>
            )}
            {opcoesFiltradas.length === 0 && (
              <div style={{ padding: "8px 12px", fontSize: 13, color: C.muted }}>{emptyLabel}</div>
            )}
            {opcoesFiltradas.map((o) => (
              <div
                key={o.value}
                onClick={() => { onChange(o.value); setAberto(false); }}
                style={{
                  padding: "8px 12px", fontSize: 13, color: C.text, cursor: "pointer",
                  background: String(o.value) === String(value) ? C.bgActive : "transparent",
                }}
                onMouseEnter={(e) => { if (String(o.value) !== String(value)) e.currentTarget.style.background = C.bgActive; }}
                onMouseLeave={(e) => { if (String(o.value) !== String(value)) e.currentTarget.style.background = "transparent"; }}
              >
                {o.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
